module.exports = __webpack_public_path__ + "img/download.5d6d8055.svg";